import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import './index.css'

// PrimeVue
import PrimeVue from "primevue/config";
import Aura from '@primevue/themes/aura';
import "primeicons/primeicons.css"; 

declare global {
  interface Window {
    paypal?: any;
  }
}

// App configuration
const app = createApp(App)
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      dark: false, // Desactiva el modo oscuro
      darkModeSelector: 'none' 
    }
  }
});
app.mount("#app");

